import axios from 'axios';
import { t } from 'i18next';

export function getErrorMessage(error: unknown, fallbackKey: string): string {
  if (axios.isAxiosError(error) && error.response?.data?.message) {
    return error.response.data.message;
  }
  return t(fallbackKey);
}
